import {Injectable} from '@angular/core';
import {Apollo} from 'apollo-angular';
import {ALLTIENDAS, TIENDA, UPDATETIENDA} from '../queries/tiendas.query';
import {TiendaEntity} from '../entities/tienda.entity';
import {getLoginUser} from './usuario.services';

@Injectable()
export class TiendaServices {

  constructor(private apollo: Apollo) {

  }

  getAllTiendas() {
    // console.log(getLoginUser());
    return this.apollo.query<any>({
      query: ALLTIENDAS,
      variables: {
        idUser: getLoginUser()
      }
    });
  }

  getTienda(id: any) {
    return this.apollo.query<any>({
      query: TIENDA,
      variables: {
        id: +id,
        idUser: getLoginUser()
      }
    });
  }

  updateTienda(tienda: TiendaEntity) {

    return this.apollo.mutate<any>({
      mutation: UPDATETIENDA,
      variables: {
        id: +tienda.id,
        categoria: tienda.categoria,
        locacion: tienda.locacion,
        negocio: tienda.negocio,
        activo: tienda.activo,
        nombre: tienda.nombre,
        horario: tienda.horario
      }
    });
  }
}
